import React from 'react';
import { FadeIn } from './ui';
export function ProblemSection() {
  return <section className="bg-white py-20 px-6 md:py-28" data-id="element-145">
      <div className="max-w-4xl mx-auto text-center" data-id="element-146">
        <FadeIn data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-8" data-id="element-148">
            ¿Por qué tu cuerpo se resiste a soltar la grasa después de los 40?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-149">
          <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-150">
            Después de los 40, la caída de estrógenos nos vuelve hipersensibles
            al estrés. Cada vez que intentas una dieta extrema, haces cardio
            agotador o tomas café en ayunas, le envías a tu cerebro una señal de
            "peligro".
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-151">
          <div className="bg-sage/30 p-8 md:p-10 rounded-2xl border border-sage/50" data-id="element-152">
            <p className="text-lg md:text-xl text-navy font-medium leading-relaxed" data-id="element-153">
              Tu cuerpo responde bloqueando la tiroides y almacenando cada
              caloría directamente en tu vientre para sobrevivir a la "hambruna"
              que cree estar viviendo. El resultado es un{' '}
              <span className="text-coral font-bold" data-id="element-154">
                metabolismo bloqueado, neblina mental y una frustración que te
                quita el sueño a las 3 de la mañana.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}